module.exports = __webpack_public_path__ + "fonts/brand-icons.c5ebe0b3.c5ebe0b3.ttf";